import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { useMutation } from '@tanstack/react-query';
import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { useWoody } from '../../woody/woody.js';
import { toast } from '../../store/alerts.js';

const useMutationMagicRename = () => {
  const { client } = useWoody();
  const { track } = useAnalytics();
  return useMutation({
    mutationFn: async (resourceId) => {
      const response = await client.v2("/v2/suggest-name", {
        method: "post",
        body: {
          resourceId
        }
      });
      if (!response) throw new Error("Not enough data.");
      return response;
    },
    onSuccess: (_, resourceId) => {
      track(AnalyticsEvents.MagicRename, {
        resourceId
      });
    },
    onError: () => {
      toast({
        id: "magic-rename-fail",
        content: "Not enough information to suggest a new name."
      });
    }
  });
};

export { useMutationMagicRename };
//# sourceMappingURL=useMutationMagicRename.js.map
